import * as React from "react";
import {Trans, useTranslation} from "react-i18next";
import window from "../components/lib/WindowExtended";
import styles from "./Footer.module.scss";
import genericStyles from "../components/lib/GenericStyles.module.scss";
import {getShopId} from "./lib/getShopId";

const links = window.c_links;

const Footer: React.FC = () => {
  const {t} = useTranslation();

  const FootNotePriceInfo: React.FC = () => {
    return (
      <span>
        {t("product.allPricesIncludeTax")}{" "}
        <Trans
          i18nKey="general.exclShipping"
          ns="translations"
          components={{
            1: <a href={t("url.deliveryLink")} target="_blank" rel="noreferrer" />,
          }}
        />
      </span>
    );
  };

  return (
    <footer className={styles.wrapper} role="contentinfo">
      <div className={styles.footerNote}>
        <p className={genericStyles.footnote}>
          <sup className={genericStyles.footnoteIcon}>*</sup>
          <FootNotePriceInfo />
        </p>
        {getShopId() === 100005 && (
          <p className={genericStyles.footnote}>
            <sup className={genericStyles.footnoteIcon}>3</sup>
            <span>
              Please note that there is no right of return for deliveries outside the European Union, excluding
              Switzerland.
            </span>
          </p>
        )}
      </div>

      <div className={styles.linksWrapper}>
        <div>
          <a href={links.URL_Privacy} target="_blank" rel="noopener noreferrer">
            {t("general.privacy")}
          </a>
          {" / "}
          <a href={links.URL_RevocationRights} target="_blank" rel="noopener noreferrer">
            {t("general.withdrawal")}
          </a>
          {" / "}
          <a href={links.URL_TermsAndConditions} target="_blank" rel="noopener noreferrer">
            {t("general.generalTerms")}
          </a>
          {" / "}
          <a href={links.URL_Imprint} target="_blank" rel="noopener noreferrer">
            {t("general.legalInformation")}
          </a>
        </div>
        <strong>
          {t("general.service")}{" "}
          <a href={`tel:${links.ContactPhone.replace(/(\s|\(|\))/g, "")}`}>{links.ContactPhone}</a>
        </strong>
      </div>
    </footer>
  );
};

export default Footer;
